if (!customElements.get('sm-kit-colour-guard')) {
  const selections = new Map();
  customElements.define('sm-kit-colour-guard', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.form = this.closest('form');
        if (!this.form) return;
        const id = this.form.getAttribute('id');
        if (!selections.has(id)) selections.set(id, { variants: new Map(), properties: new Map() });
        this.choices = selections.get(id);
        this.propertyFields = Array.from(this.form.querySelectorAll('[data-sm-kit-colour-fields] select[required]'));
        for (const field of this.propertyFields) {
          const value = this.choices.properties.get(field.name);
          if (value && Array.from(field.options).some(option => option.value === value && !option.disabled)) field.value = value;
        }
        const signal = this.controller.signal;
        const choose = event => {
          const input = event.target;
          if (input.form !== this.form) return;
          if (input instanceof HTMLInputElement && input.matches('input[data-option-position]')) {
            this.choices.variants.set(input.dataset.optionPosition, input.value);
          } else if (input instanceof HTMLSelectElement && this.propertyFields.includes(input)) {
            this.choices.properties.set(input.name, input.value);
          } else {
            return;
          }
          this.sync();
        };
        document.addEventListener('click', choose, { capture: true, signal });
        document.addEventListener('change', choose, { capture: true, signal });
        this.form.addEventListener('variant:change', () => this.sync(), { signal });
        this.form.addEventListener('submit', event => {
          if (this.sync()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const missing = this.propertyFields.find(field => !field.value);
          if (missing) {
            missing.focus();
            missing.reportValidity();
          } else {
            this.picker?.querySelector('[data-sm-colour-pending] button')?.focus();
          }
        }, { capture: true, signal });
        this.sync();
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    sync() {
      if (!this.form?.isConnected) return false;
      this.picker = Array.from(document.querySelectorAll('variant-picker')).find(picker => picker.getAttribute('form-id') === this.form.getAttribute('id'));
      const required = Number(this.dataset.variantOptions || 0);
      const fields = required && this.picker ? Array.from(this.picker.querySelectorAll('.variant-picker__option')) : [];
      let complete = fields.length === required;
      for (const field of fields) {
        const input = field.querySelector('input[data-option-position]:checked');
        const confirmed = input && this.choices.variants.get(input.dataset.optionPosition) === input.value;
        field.toggleAttribute('data-sm-colour-pending', !confirmed);
        const selectedLabel = field.querySelector('[id$="-selected-value"]');
        if (selectedLabel) {
          const label = input && (input.closest('label') || this.picker.querySelector('label[for="' + CSS.escape(input.id) + '"]'));
          selectedLabel.textContent = confirmed ? label?.querySelector('span')?.textContent.trim() || input.value : this.dataset.chooseLabel;
        }
        if (!confirmed || !input.defaultChecked) complete = false;
      }
      if (required) {
        try {
          const variant = JSON.parse(this.picker?.querySelector('script[data-variant]')?.textContent || '{}');
          if (String(variant.id || '') !== this.form.elements.namedItem('id')?.value) complete = false;
        } catch {
          complete = false;
        }
      }
      if (this.propertyFields.some(field => !field.value || !field.checkValidity())) complete = false;
      for (const button of Array.from(this.form.elements).filter(element => element.type === 'submit')) {
        button.disabled = !complete || this.dataset.available !== 'true';
      }
      this.hidden = complete;
      return complete && this.dataset.available === 'true';
    }
  });
}
